import type { ReactNode } from 'react';

export function EmptyState({ title, subtitle, action }: { title: string; subtitle?: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center text-[var(--color-text-secondary)]">
      <h2 className="text-lg font-semibold text-[var(--color-text)] mb-2">{title}</h2>
      {subtitle ? <p className="text-sm mb-4">{subtitle}</p> : null}
      {action}
    </div>
  );
}
